import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'

const TextContent = () => {
    const listItems = [
        "Efficient paperless onboarding",
        "Compliance with local employment regulations",
        "Electronic worker verification process",
        "Timesheet management",
        "Data insights and analytics into your placements",
      ];
  return (
    <>
    <div className="wrapper">
        <div className="textcontentservice">
            <h1>Tech Designed for <span> Contractor Management</span></h1>
            <p>We’re a people-centric business and in addition to our human support, we use our own purpose-built workforce management technology to propel the experience of working with Ampstekpay even further.</p>
            <p>Our tech is built with staffing firms at heart, so that you can easily manage your contractors at the click of a button.</p>
            <p>By partnering with Ampstekpay, you can enjoy: </p>
            <div className="listcontent">
                <ul>
                    {listItems.map((item, index) => (
                         <li key={index}><FontAwesomeIcon
                         icon={faCheckCircle} style={{
                            color: "rgb(255 102 204)", // Green color
                          }}/>&nbsp;&nbsp;&nbsp;{item}</li>
                    ))}
                </ul>
                <br/>
            </div>
            <p>Best of all, we consistently invest in our tech so that it evolves to meet the growing global needs of staffing firms.</p>
        </div>
    </div>
    </>
  )
}

export default TextContent